import Lottie from 'lottie-react';
import worktualLoader from "./worktual-loader.json"
import Loader from '../../../src/styles/images/loader.gif'

const Loaders = () => {
  return (
    <>
      <div className={"loaders"}>
        {/* <Lottie
          style={{ width: 100, margin: "0 auto" }}
          animationData={worktualLoader}
        /> */}
        <img src={Loader} alt="Loader" className='loadermain'/>
      </div>
    </>
  );
};
export default Loaders;